/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

import s from '../../../assets/styles/style.sass';
import s2 from '../Header.sass';
import LoginModule from '../../Login/LoginModule';
import RegisterModule from '../../Login/RegisterModule';
import UpdateUserInfoModule from '../../Login/UpdateUserInfoModule';
import ExpiredLoginDialog from '../../Dialog/expiredLoginDialog';
import RegisterButton from '../Button/RegisterButton';
import LoginButton from '../Button/LoginButton';
import { returnLocaleText } from '../../../service/util';
import { getLink } from '../../../service/asset-json';

import imgDropdownArrow from '../../../assets/img/icon_dropdownarrow_grey.png';
import imgAvator from '../../../assets/img/icon_avator40x40.png';
import imgAvator2 from '../../../assets/img/icon_avator40x40@2x.png';

import {
  setUserInfo,
  setIsShowLoginModal,
  setIsShowUpdateUserModal,
} from '../../../actions/user';

import { localStorageGet } from '../../../service/localStorage';
import { logout } from '../../../api/user';

class MenuRight extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setUserInfo: PropTypes.func.isRequired,
    user: PropTypes.shape(),
    fromNormalHeader: PropTypes.bool,
  };

  static defaultProps = {
    fromNormalHeader: false,
  };

  static defaultProps = {
    user: null,
  };
  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      dropdownOpen: false,
      // ensure fetched data from localStorage
      isShowMenu: false,
      modelDataDefaultLink: require(`../../../assets/json/default/setting/general/link.json`),
      modelDataLink: require(`../../../assets/json/${lang}/${fileLang}setting/general/link.json`),
      modelDataSetting: require(`../../../assets/json/${
        lang === 'hk' ? 'default' : lang
      }/setting/general/setting.json`),
      modelDataDefaultLocale: require(`../../../assets/json/default/setting/general/locale.json`),
      modelDataLocale: require(`../../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
    };
    this.toggle = this.toggle.bind(this);
    // this.setUserInfo = this.setUserInfo.bind(this);
  }

  componentWillMount() {
    if (localStorageGet('auth.id', false) !== null) {
      const email = localStorageGet('auth.email', false);
      const password = localStorageGet('auth.password', false);
      const phone = localStorageGet('auth.phone', false);

      if (!((email || phone) && password)) {
        return false;
      }

      const id = localStorageGet('auth.id', false);
      const username = localStorageGet('auth.username', false);
      const verified = localStorageGet('auth.verified', false);
      const addresses = localStorageGet('auth.addresses', false);
      const gender = localStorageGet('auth.gender', false);
      const industry = localStorageGet('auth.industry', false);
      const dateOfBirth = localStorageGet('auth.date_of_birth', false);
      const receiveGogovanUpdates = localStorageGet(
        'auth.has_agreed_to_receive_gogovan_updates',
        false,
      );
      const receiveThirdPartiesUpdates = localStorageGet(
        'auth.has_agreed_to_receive_third_parties_updates',
        false,
      );

      const profilePhoto = localStorageGet('auth.profile_photo', false);
      const user = {
        id,
        email,
        password,
        name: username,
        phone,
        verified,
        addresses,
        profilePhoto,
        receiveGogovanUpdates,
        receiveThirdPartiesUpdates,
        gender,
        industry,
        dateOfBirth,
      };
      this.props.setUserInfo(user);
    }
    return true;
  }

  componentDidMount() {
    this.setIsShowMenu();
  }

  setIsShowMenu() {
    this.setState({ isShowMenu: true });
  }

  setUserInfo() {
    logout();
    this.props.setUserInfo(null);
    const href = getLink('sign_in', this.props.currentLocale);

    window.location.href = href;
  }

  getPage(page) {
    if (page === 'dashboard') {
      const href =
        typeof this.state.modelDataLink[page] === 'undefined'
          ? this.state.modelDataDefaultLink[page]
          : this.state.modelDataLink[page];
      window.location.href = href;
    } else if (page === 'sign_out') {
      this.setUserInfo();
    } else {
      const href =
        typeof this.state.modelDataLink[page] === 'undefined'
          ? this.state.modelDataDefaultLink[page]
          : this.state.modelDataLink[page];
      window.location.href = href;
    }
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  render() {
    const { user } = this.props;
    return (
      <nav className={s.headerMenuRight}>
        {this.state.modelDataSetting.enable_ordering &&
        this.state.isShowMenu ? (
          <span>
            {user === null ? (
              <span className={`${s.headerMenuRightItem} ${s.twinButton}`}>
                <LoginButton />
                <RegisterButton />
              </span>
            ) : (
              <ul>
                <li className={s.headerMenuRightItem} id="headerMenuUser">
                  <Dropdown
                    isOpen={this.state.dropdownOpen}
                    toggle={this.toggle}
                    className={s2.dropdownMenuRight}
                  >
                    <DropdownToggle
                      tag="span"
                      onClick={this.toggle}
                      aria-expanded={this.state.dropdownOpen}
                    >
                      <span className={s2.nameLong}>{user.name}</span>
                      <span className={s2.nameShort}>
                        {user.name
                          .split(' ')
                          .map(x => x[0])
                          .join('')}
                      </span>
                      <img
                        className={`${s.userImage}`}
                        srcSet={`${imgAvator} 1x, ${imgAvator2} 2x`}
                        width="40"
                        alt="user icon"
                      />
                      <img
                        alt="arrow"
                        className={s2.dropdownMenuRight__arrow}
                        src={imgDropdownArrow}
                        width="9"
                      />
                    </DropdownToggle>
                    <DropdownMenu
                      className={`${s2.dropdownmenu} ${
                        this.props.fromNormalHeader
                          ? s2.dropHeading
                          : s2.dropOrderHeading
                      }`}
                      // onMouseLeave={() => {
                      //   this.toggle();
                      // }}
                      onBlur={() => {}}
                    >
                      {this.state.modelDataSetting.header.options.map(i => (
                        <div
                          key={i}
                          tabIndex="0"
                          onClick={e => {
                            e.preventDefault();
                            this.getPage(i);
                          }}
                          onKeyPress={() => {}}
                          role="button"
                        >
                          {returnLocaleText(
                            this.state.modelDataLocale[`page_${i}`],
                            this.state.modelDataDefaultLocale[`page_${i}`],
                          )}
                        </div>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </li>
              </ul>
            )}
          </span>
        ) : (
          <ul>
            {/*
              <li className={s.headerMenuRightItem} style={{ display: 'block' }}>
                <a
                  href="/download"
                  data-offset="-114"
                  className={`${s.button} ${s.outlined}`}
                >
                  {typeof this.state.modelDataLocale.download_our_app ===
                  'undefined'
                    ? this.state.modelDataDefaultLocale.download_our_app
                    : this.state.modelDataLocale.download_our_app}
                </a>
              </li>
            */}
          </ul>
        )}
        <LoginModule />
        <RegisterModule />
        <UpdateUserInfoModule />
        <ExpiredLoginDialog />
      </nav>
    );
  }
}

const mapState = state => ({
  user: state.user.user,
  currentLocale: state.intl.locale,
});

const mapDispatch = {
  setUserInfo,
  setIsShowLoginModal,
  setIsShowUpdateUserModal,
};

export default connect(mapState, mapDispatch)(withStyles(s, s2)(MenuRight));



// WEBPACK FOOTER //
// ./src/components/Header/Header/MenuRight.js